import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SiteDailyCountEventVm } from '../shared/generated/Sites/Models/DailyCount/SiteDailyCountEventVm';
import { HolidayListVm } from '../shared/generated/Sites/Models/Holidays/HolidayListVm';
import { SiteDetailVm } from '../shared/generated/Sites/Models/SiteDetailVm';

@Injectable({
	providedIn: 'root',
})
export class SiteService {
	constructor(private httpClient: HttpClient) {}

	getModel(id: number, orgId: string = ""): Observable<SiteDetailVm> {
		const httpParams = new HttpParams()
			.set('id', id)
			.set('orgId', (orgId === "" && orgId !== undefined ? null : orgId));
		return this.httpClient.get<SiteDetailVm>('api/Site/SiteDetail/GetModel', { params: httpParams });
	}

	getDailyCountEvent(id: number) {
		const httpParams = new HttpParams().set('id', id);
		return this.httpClient.get<SiteDailyCountEventVm>('api/Site/SiteDailyCountInventory/GetModelBySite', { params: httpParams });
	}

	getDailyCountEventByPrimaryKey(id: number) {
		const httpParams = new HttpParams().set('id', id);
		return this.httpClient.get<SiteDailyCountEventVm>('api/SiteDailyCountEvent/GetViewModelById', { params: httpParams });
	}

	getPublicDailyCountEvent(code: string) {
		const httpParams = new HttpParams().set('code', code);
		return this.httpClient.get<SiteDailyCountEventVm>('api/SiteDailyCountEvent/GetModel', { params: httpParams });
	}

	getHolidays() { return this.httpClient.get<HolidayListVm>('api/Site/Holiday/GetHolidays'); }
}
